var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetPaidSingleCurrency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 654.109,
    height: 367,
    viewBox: "0 0 654.109 367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_14",
    x: 0,
    y: 0,
    width: 488,
    height: 367,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38349",
    x: 516.5,
    y: 41.049,
    width: 63.609,
    height: 34.901,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#111",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38349-2",
    x: 381.5,
    y: 148.146,
    width: 63.609,
    height: 34.901,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#111",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38349-3",
    x: 590.5,
    y: 95.049,
    width: 63.609,
    height: 34.901,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#111",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38349-4",
    x: 516.5,
    y: 147.049,
    width: 63.609,
    height: 34.901,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#111",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38349-5",
    x: 590.5,
    y: 201.049,
    width: 63.609,
    height: 34.901,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#111",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_38349-6",
    x: 516.5,
    y: 253.049,
    width: 63.609,
    height: 34.901,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#111",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173161",
    "data-name": "Group 173161",
    transform: "translate(-3335 15730)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173130",
    "data-name": "Group 173130",
    transform: "translate(2342 1570)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 993, -17300)",
    filter: "url(#Rectangle_14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14-2",
    "data-name": "Rectangle 14",
    transform: "translate(75 55)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 217,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 337,
    height: 216,
    rx: 19.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "PAYMENT_DETAIL",
    "data-name": "PAYMENT DETAIL",
    transform: "translate(1100 -17213)",
    fill: "#172026",
    fontSize: 14,
    fontFamily: "NunitoSans-Bold, Nunito Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PAYMENT DETAIL")), /*#__PURE__*/React.createElement("text", {
    id: "Account_Number",
    "data-name": "Account Number",
    transform: "translate(1100 -17187)",
    fill: "#91959c",
    fontSize: 14,
    fontFamily: "NunitoSans-Regular, Nunito Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account Number")), /*#__PURE__*/React.createElement("text", {
    id: "DE12_3456_7890_1234",
    "data-name": "DE12 3456 7890 1234",
    transform: "translate(1100 -17161)",
    fill: "#172026",
    fontSize: 14,
    fontFamily: "NunitoSans-Regular, Nunito Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DE12 3456 7890 1234")), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 232,
    transform: "translate(1100.5 -17152.082)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Reference",
    transform: "translate(1100 -17077)",
    fill: "#91959c",
    fontSize: 14,
    fontFamily: "NunitoSans-Regular, Nunito Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Reference")), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 63,
    transform: "translate(1100.5 -17045.5)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_13-54836",
    "data-name": "13-54836",
    transform: "translate(1100 -17054)",
    fill: "#172026",
    fontSize: 14,
    fontFamily: "NunitoSans-Regular, Nunito Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "13-54836")), /*#__PURE__*/React.createElement("text", {
    id: "Expiration",
    transform: "translate(1286.5 -17130.557)",
    fill: "#666",
    fontSize: 12,
    fontFamily: "ProximaNova-Regular, Proxima Nova"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Expiration")), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 87,
    transform: "translate(1287 -17099.057)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_10_2023",
    "data-name": "10 / 2023",
    transform: "translate(1286.5 -17107.557)",
    fill: "#172026",
    fontSize: 14,
    fontFamily: "NunitoSans-Regular, Nunito Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10 / 2023")), /*#__PURE__*/React.createElement("text", {
    id: "Account_holder",
    "data-name": "Account holder",
    transform: "translate(1100.5 -17130.516)",
    fill: "#91959c",
    fontSize: 14,
    fontFamily: "NunitoSans-Regular, Nunito Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Account holder")), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 222,
    transform: "translate(1101 -17099.016)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Richard_Hendricks",
    "data-name": "Richard Hendricks",
    transform: "translate(1100.5 -17107.516)",
    fill: "#172026",
    fontSize: 14,
    fontFamily: "NunitoSans-Regular, Nunito Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Richard Hendricks")), /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 82,
    height: 31,
    rx: 4,
    transform: "translate(1291 -17080)",
    fill: "#321844"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Confirm",
    transform: "translate(1307 -17060)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "HelveticaNeue, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Confirm")), /*#__PURE__*/React.createElement("text", {
    id: "PALEO_PAY",
    "data-name": "PALEO PAY",
    transform: "translate(1265.5 -17229.156)",
    fill: "#321844",
    fontSize: 20,
    fontFamily: "ProximaNova-Semibold, Proxima Nova",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.16,
    y: 18
  }, "PALEO "), /*#__PURE__*/React.createElement("tspan", {
    y: 18,
    fontFamily: "ProximaNova-Light, Proxima Nova",
    fontWeight: 300
  }, "PAY"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_173151",
    "data-name": "Group 173151",
    transform: "translate(42.414 19.921)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3292.59, -15749.92)",
    filter: "url(#Path_38349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38349-7",
    "data-name": "Path 38349",
    d: "M13.652,0h27.3C48.5,0,54.609,5.8,54.609,12.951S48.5,25.9,40.957,25.9h-27.3C6.112,25.9,0,20.1,0,12.951S6.112,0,13.652,0Z",
    transform: "translate(521 44.55)",
    fill: "#321844"
  })), /*#__PURE__*/React.createElement("text", {
    id: "GBP",
    transform: "translate(3840.188 -15687.827)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.133,
    y: 0
  }, "GBP"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_173160",
    "data-name": "Group 173160",
    transform: "translate(-92.586 127.019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3427.59, -15857.02)",
    filter: "url(#Path_38349-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38349-8",
    "data-name": "Path 38349",
    d: "M13.652,0h27.3C48.5,0,54.609,5.8,54.609,12.951S48.5,25.9,40.957,25.9h-27.3C6.112,25.9,0,20.1,0,12.951S6.112,0,13.652,0Z",
    transform: "translate(386 151.65)",
    fill: "#334ac0"
  })), /*#__PURE__*/React.createElement("text", {
    id: "EUR",
    transform: "translate(3840.188 -15687.827)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.09,
    y: 0
  }, "EUR"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_173158",
    "data-name": "Group 173158",
    transform: "translate(116.414 73.921)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3218.59, -15803.92)",
    filter: "url(#Path_38349-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38349-9",
    "data-name": "Path 38349",
    d: "M13.652,0h27.3C48.5,0,54.609,5.8,54.609,12.951S48.5,25.9,40.957,25.9h-27.3C6.112,25.9,0,20.1,0,12.951S6.112,0,13.652,0Z",
    transform: "translate(595 98.55)",
    fill: "#321844"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AUD",
    transform: "translate(3840.188 -15687.827)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.91,
    y: 0
  }, "AUD"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_173153",
    "data-name": "Group 173153",
    transform: "translate(42.414 125.921)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3292.59, -15855.92)",
    filter: "url(#Path_38349-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38349-10",
    "data-name": "Path 38349",
    d: "M13.652,0h27.3C48.5,0,54.609,5.8,54.609,12.951S48.5,25.9,40.957,25.9h-27.3C6.112,25.9,0,20.1,0,12.951S6.112,0,13.652,0Z",
    transform: "translate(521 150.55)",
    fill: "#321844"
  })), /*#__PURE__*/React.createElement("text", {
    id: "USD",
    transform: "translate(3840.188 -15687.827)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.161,
    y: 0
  }, "USD"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_173156",
    "data-name": "Group 173156",
    transform: "translate(116.414 179.921)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3218.59, -15909.92)",
    filter: "url(#Path_38349-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38349-11",
    "data-name": "Path 38349",
    d: "M13.652,0h27.3C48.5,0,54.609,5.8,54.609,12.951S48.5,25.9,40.957,25.9h-27.3C6.112,25.9,0,20.1,0,12.951S6.112,0,13.652,0Z",
    transform: "translate(595 204.55)",
    fill: "#321844"
  })), /*#__PURE__*/React.createElement("text", {
    id: "INR",
    transform: "translate(3840.188 -15687.827)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.578,
    y: 0
  }, "INR"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_173155",
    "data-name": "Group 173155",
    transform: "translate(42.414 231.921)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3292.59, -15961.92)",
    filter: "url(#Path_38349-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38349-12",
    "data-name": "Path 38349",
    d: "M13.652,0h27.3C48.5,0,54.609,5.8,54.609,12.951S48.5,25.9,40.957,25.9h-27.3C6.112,25.9,0,20.1,0,12.951S6.112,0,13.652,0Z",
    transform: "translate(521 256.55)",
    fill: "#321844"
  })), /*#__PURE__*/React.createElement("text", {
    id: "CNY",
    transform: "translate(3840.188 -15687.827)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.973,
    y: 0
  }, "CNY"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetPaidSingleCurrency);
export default __webpack_public_path__ + "static/media/get-paid-single-currency.12cf0acae02472df2e76e8e982390185.svg";
export { ForwardRef as ReactComponent };